// extracted by mini-css-extract-plugin
export default {"lastSave":"S3TUd","form":"c7TJC","header":"v5gU2","name":"S7WF8","actions":"xMkhg","action":"ysmFx"};